import styled, { css, CSSProp } from 'styled-components';
import { Button, IMForm } from '@insurancemenu/imenu-components-lib';

export const IMFormStyled = styled(IMForm)<{ $isNewMemberForm: boolean }>`
  margin: 0 auto;
  position: relative;
  width: 100%;
  ${({ $isNewMemberForm }): CSSProp =>
    !$isNewMemberForm &&
    css`
      padding-top: 4rem;
    `}
`;

export const DeleteButtonStyled = styled(Button)`
  position: absolute;
  top: 0;
  right: 2rem;
  padding: 0;
`;
